import { Card, Row, Col, Form, Checkbox, Input, DatePicker } from "antd";
import { forwardRef, useImperativeHandle, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { update_cctanf_form } from "../../actions/form_slice";
import { debounce } from "lodash";

const CC_TANF = forwardRef(({ onValuesChange }, ref) => {
  const [form] = Form.useForm();

  useImperativeHandle(ref, () => ({
    getFieldsError: form.getFieldsError,
    validateFields: form.validateFields,
    resetFields: form.resetFields,
    setFieldsValue: form.setFieldsValue,
    submit: form.submit,
    getFieldsValue: form.getFieldsValue,
  }));

  const dispatch = useDispatch();
  const formData = useSelector((state) => state.form.cctanf_form_type);

  const handleFormChange = debounce((changedValues) => {
    dispatch(update_cctanf_form(changedValues));
    onValuesChange(formData);
  }, 300);
  // useEffect(() => {
  //   console.log("[CC_TANF][useEffect]");
  // }, [form]);
  return (
    <Form
      form={form}
      onValuesChange={handleFormChange}
      // onFinish={props.onFinish}
      labelAlign="justify"
      layout="vertical"
      labelWrap
      wrapperCol={{
        flex: 1,
      }}
    >
      <Form.Item
        valuePropName="checked"
        name="ES-3102 given to and discussed with applicant ES-3102  ES-3102S  (interviewed)"
      >
        <Checkbox
          value="ES-3102 given to and discussed with applicant ES-3102  ES-3102S  (interviewed)
"
        >
          ES-3102 given to and discussed with applicant &nbsp;
          {
            <a
              style={{ DisplayFormat: "inline-block", color: "Red", font: "1.2rem", textDecoration: "none" }}
              href="http://content.dcf.ks.gov/ees/KEESM/Forms/ES-3102_ImportantInformationAboutCooperationWithChild"
              target="_blank"
              rel="noreferrer"
            >
              &nbsp;
              ES-3102
            </a>
          }
          &ensp;
         {
            <a
              style={{ DisplayFormat: "inline-block", color: "Red", font: "1.2rem", textDecoration: "none"  }}
              href="http://content.dcf.ks.gov/ees/KEESM/Forms/ES-3102S_ImportantInformationAboutCooperationWithChild Support10-21.pdf"
              target="_blank"
              rel="noreferrer"
            >
              ES-3102S
            </a>
          }
          &ensp;(interviewed)
        </Checkbox>
      </Form.Item>
      <Form.Item
        valuePropName="checked"
        name="ES-3102 mailed to applicant (No Interview)"
      >
        <Checkbox
          value="ES-3102 mailed to applicant (No Interview)
"
        >
          ES-3102 mailed to applicant (No Interview)
        </Checkbox>
      </Form.Item>
    </Form>
  );
});
export default CC_TANF;
